import { NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { DatasearchService } from '../../_services/datasearch.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-gallery',
  standalone: true,
  imports: [FooterComponent, HeaderComponent, NgFor, NgIf],
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent {
  transparent = false;
  galleryData: any[] = [];
  galleryArr: any[] = [];
  div1Images: any[] = [];
  div2Images: any[] = [];
  div3Images: any[] = [];
  div5Images: any[] = [];
  imageBaseUrl = 'https://www.chemrobotics.com/agropat/uploads/gallery/';
  currentIndex = 0; // To keep track of the current index for slicing
  itemsPerPage = 5;
  head: any[] = [];
  currentPage: string = 'gallery';
  currentUrl: string;

  constructor(private datasearch: DatasearchService, private router: Router) {
    this.currentUrl = window.location.href;
    this.imageBaseUrl = this.datasearch.ApiUrl + '/uploads/gallery/';
  }

  ngOnInit() {
    this.getHeading();
    this.getGalleryData();
  }

  getGalleryData() {
    this.datasearch.getGallary().subscribe(res => {
      this.galleryData = res.data;
      this.setGalleryArr();
      this.distributeImages();
    });
  }

  setGalleryArr() {
    // Handle wrapping around the end of the array
    this.galleryArr = [];
    for (let i = 0; i < this.itemsPerPage; i++) {
      this.galleryArr.push(this.galleryData[(this.currentIndex + i) % this.galleryData.length]);
    }
  }

  distributeImages() {
    // Clear existing arrays
    this.div1Images = [];
    this.div2Images = [];
    this.div3Images = [];
    this.div5Images = [];

    const totalImages = this.galleryData.length;

    if (totalImages >= 5) {
      this.div5Images = this.galleryData.slice(0, 5);
      this.galleryData = this.galleryData.slice(5);
    }

    if (this.galleryData.length > 0) {
      if (this.galleryData.length === 1) {
        this.div1Images = this.galleryData;
      } else if (this.galleryData.length <= 3) {
        this.div2Images = this.galleryData;
      } else if (this.galleryData.length === 4) {
        this.div3Images = this.galleryData;
      }
    }
  }

  leftClick() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = (this.div2Images.length || this.div3Images.length) - 1;
    }
    this.setGalleryArr();
  }

  rightClick() {
    this.currentIndex = (this.currentIndex + 1) % (this.div2Images.length || this.div3Images.length);
    this.setGalleryArr();
  }

  goToGallaryDetail(_id: any) {
    this.router.navigate(['/gallary_detail', _id]);
  }

  getHeading() {
    this.datasearch.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }

  getGalleryImageUrl(gallery: any): string {
    const filename = gallery.poster || gallery.logo || gallery.image || gallery.gallery_logo;
    if (!filename) return 'https://www.chemrobotics.com/agropat/uploads/gallery/placeholder.png'; // fallback placeholder

    if (filename.toString().startsWith('http')) {
      return filename;
    }

    // Standard Folder for Gallery Posters (Hyphenated as confirmed)
    return this.datasearch.ApiUrl + '/uploads/gallery-posters/' + filename;
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }
}
